<div *ngIf="acceptReservation" class="reservation-pannel activity column">
    <div class="activity-header">
        <app-activity-common-header></app-activity-common-header>
    </div>
    <app-message [messageInfo]="activityService.message" (closeEvent)="closeMessage($event)"
        *ngIf="activityService.message.message && activityService.message.message !== ''"></app-message>
    <div class="activity__content">

        <div class="activity-booking" *ngIf="isDataLoaded">
            <mat-tab-group [(selectedIndex)]="SelectedTab">
                <mat-tab>
                    <app-activity-booking [hidden]="SelectedTab !== ComponentTab.BookingSelection">
                    </app-activity-booking>
                </mat-tab>
                <mat-tab>
                    <app-class-info [hidden]="SelectedTab !== ComponentTab.ActvityView"></app-class-info>
                </mat-tab>
                <mat-tab>
                    <app-activity-selector *ngIf="SelectedTab !== ComponentTab.CartDetails"
                        [hidden]="SelectedTab !== ComponentTab.ActivitySelection">
                    </app-activity-selector>
                </mat-tab>
                <mat-tab>
                    <app-private-activity-booking [hidden]="SelectedTab !== ComponentTab.PrivateLesson">
                    </app-private-activity-booking>
                </mat-tab>
                <mat-tab>
                    <app-activity-summary [hidden]="SelectedTab !== ComponentTab.ReservationDetails">
                    </app-activity-summary>
                </mat-tab>
                <mat-tab>
                    <app-cart-details
                        *ngIf="SelectedTab === ComponentTab.CartDetails || activityService.isSummaryFromCart">
                    </app-cart-details>
                </mat-tab>
                <mat-tab>
                    <app-activity-booking-summary [hidden]="SelectedTab !== ComponentTab.ConfirmationSummary">
                    </app-activity-booking-summary>
                </mat-tab>
                <mat-tab>
                    <app-activity-additionalguest [hidden]="SelectedTab !== ComponentTab.AdditionalGuest">
                    </app-activity-additionalguest>
                </mat-tab>


            </mat-tab-group>
        </div>
    </div>
    <div class="activity-footer">
        <app-activity-common-footer></app-activity-common-footer>
    </div>
</div>
<div *ngIf="!acceptReservation && outOfServiceMessage">
    <app-message [messageInfo]="outOfServiceMessage" (closeEvent)="closeMessage($event)"></app-message>
</div>